import { entryArtistIds } from '@shared/lineupActs'
import { SetDetailDialog, type SetDetailTab } from '../../../components/SetDetailDialog'
import type { Artist, Group, LineupEntry, UserProfile } from '../../../types'
import { actCardLabel, actUserIds, isActFollowed } from './lineupActCard'
import { CollabIntro } from './CollabIntro'

const noPost = async () => {}
const noop = () => {}

/**
 * A b2b or collab act's detail from the lineup: a heading and follow heart per
 * performer. A named collab owns the header — its photo, name and heart — and
 * its bio sits right under the cover, so the body reads as its members rather
 * than one more artist. No feed — posts
 * are per artist, and an act has no single artist to post to.
 */
export function LineupActDialog({
  entry,
  tab,
  onTabChange,
  onClose,
  artists,
  interestedArtistIds,
  followHintIds,
  onToggleArtist,
  artistUserIds,
  userProfiles,
  currentUserId,
  groups,
  isGuest,
  onRequireAuth,
}: {
  entry: LineupEntry
  tab: SetDetailTab
  onTabChange: (tab: SetDetailTab) => void
  onClose: () => void
  artists: Record<string, Artist>
  interestedArtistIds: ReadonlySet<string>
  followHintIds: ReadonlySet<string>
  onToggleArtist: (artistId: string) => void
  artistUserIds: Record<string, string[]>
  userProfiles: Record<string, UserProfile>
  currentUserId?: string | null
  groups: Group[]
  isGuest: boolean
  onRequireAuth: () => void
}) {
  const { name, tagline } = actCardLabel(entry, artists)
  const shown = entryArtistIds(entry).map(id => artists[id]).filter((a): a is Artist => !!a)
  const collab = entry.collabArtistId ? artists[entry.collabArtistId] : undefined
  return (
    <SetDetailDialog
      open
      onOpenChange={open => { if (!open) onClose() }}
      tab={tab}
      onTabChange={onTabChange}
      name={name}
      subtitle={tagline ?? entry.note}
      artists={shown}
      coverArtists={collab?.imageUrl ? [collab] : undefined}
      intro={collab && <CollabIntro artistId={collab.id} />}
      titled
      interestedMemberIds={actUserIds(entry, artistUserIds)}
      goingMemberIds={[]}
      currentUserStatus={(collab ? interestedArtistIds.has(collab.id) : isActFollowed(entry, interestedArtistIds)) ? 'interested' : null}
      onToggle={collab ? () => onToggleArtist(collab.id) : undefined}
      posts={[]}
      profiles={userProfiles}
      currentUserId={currentUserId}
      groups={groups}
      isGuest={isGuest}
      onRequireAuth={onRequireAuth}
      onCreatePost={noPost}
      onDeletePost={noop}
      hideFeed
      artistHeart={id => ({ followed: interestedArtistIds.has(id), followHint: followHintIds.has(id), onToggle: () => onToggleArtist(id) })}
    />
  )
}
